import { Component, OnInit, Input } from '@angular/core';
import { SectionService } from './section.service';
import { CustomService } from '../custom.service';
import {
    ObjectNames,
    Severity,
    Answer,
    CommonCustomAttributes,
} from "../../constants/constants";
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { AppMainComponent } from 'src/app/app.main.component';
import { ConfirmationService, MessageService } from 'primeng/api';
import { TitleCasePipe } from '@angular/common';

@Component({
  selector: 'app-section',
  templateUrl: './section.component.html',
  styleUrls: ['./section.component.scss']
})
export class SectionComponent implements OnInit {

  sectionForm: FormGroup;
  allSections = [];
  allModuleNames = [];
  @Input() moduleList = [];
  selectedModule;
  allTemplates = [];
  selectedTemplate;
  sectionConfig;
  inventoryObjId;
  addEditSectionHeader;
  displaySectionAddEdit = false;
  invalidData = false;
  isAddSection: boolean = true;
  displaySectionAvailability: boolean = false;
  statusDisabled: boolean=false;


  constructor(private sectionService: SectionService, private customService: CustomService,
    private fb: FormBuilder, private app: AppMainComponent, private titlecasePipe: TitleCasePipe,
    private messageService: MessageService, private confirmationService: ConfirmationService) { }

  ngOnInit(): void {
    this.customService.getSection().subscribe(section => {
      if(section){
        this.showAddCustomSection();
      }
    });
    this.sectionForm = this.fb.group({
      id: [0],
      createdBy: [''],
      createdDate: [''],
      createdSource: [''],
      createdUser: [''],
      isActive: [true],
      isAvailable: [true],
      isDefault: [false],
      name: [''],
      systemGenerated: [false],
      module: [''],
      moduleId: [''],
      typeId: [''],
      type: [''],
      updateSource: [''],
      updatedBy: [''],
      updatedDate: ['']
    });

    //this.getConfigurationTypes();
    this.getModules();

  }

  getConfigurationTypes() {
    this.inventoryObjId = this.sectionForm.controls['moduleId'].value.id;
    this.selectedModule= this.sectionForm.controls['moduleId'].value;
    if(this.sectionForm.controls['moduleId'].value.name==ObjectNames.OrdersConstants.orderFieldName){
      this.sectionService.getAllTypes().subscribe(types => {
        const channelTypeId = types.filter(type => type.name == ObjectNames.OrdersConstants.Orders_Submodule_TypeName)[0].id;
        const sectionTypeId = types.filter(type => type.name == ObjectNames.customConstants.Inventory_Section_TypeName)[0].id;
        this.loadConfigurations(channelTypeId, sectionTypeId);
      })
    }else if(this.sectionForm.controls['moduleId'].value.name==ObjectNames.purchaseOrderConstants.purchaseFieldName){
      this.sectionService.getAllTypes().subscribe(types => {
        const channelTypeId = types.filter(type => type.name == ObjectNames.purchaseOrderConstants.Purchase_Submodule_TypeName)[0].id;
        const sectionTypeId = types.filter(type => type.name == ObjectNames.customConstants.Inventory_Section_TypeName)[0].id;
        this.loadConfigurations(channelTypeId, sectionTypeId);
      })
    }else{
      this.sectionService.getAllTypes().subscribe(types => {
        const channelTypeId = types.filter(type => type.name == ObjectNames.productConstants.Inventory_Types_TypeName)[0].id;
        const sectionTypeId = types.filter(type => type.name == ObjectNames.customConstants.Inventory_Section_TypeName)[0].id;
        this.loadConfigurations(channelTypeId, sectionTypeId);
      })
    }

  }

  loadConfigurations(typeId, sectionId) {
    if(this.sectionForm.controls['moduleId'].value.name==ObjectNames.OrdersConstants.orderFieldName){
      this.sectionService.getConfigurationsByModuleName('Order').subscribe(configs => {
        const typeConfig = configs.filter(s => s.name == ObjectNames.OrdersConstants.Orders_Submodule_Object && s.typeId == typeId)[0];
        // this.allTemplates = JSON.parse(typeConfig.configurationDetails[0].configJSONValue);
        /**
         * to make estimates, salesorder and invoice as a single option
         */
        const orderTemplates = JSON.parse(
            typeConfig.configurationDetails[0].configJSONValue
        );
        const res = [];
        orderTemplates.forEach((element) => {
            if (
                element.name == "Credit Memo" ||
                element.name == "Customer Returns"
            ) {
                res.push(element);
            }
        });
        res.push(CommonCustomAttributes);
        this.allTemplates = res;
        this.sectionForm.controls['typeId'].setValue(this.allTemplates[0]);
        this.sectionConfig = configs.filter(s => s.name == ObjectNames.customConstants.Order_Section_Object && s.typeId == sectionId)[0];
        this.allSections = JSON.parse(this.sectionConfig.configurationDetails[0].configJSONValue);
      });
    }else if(this.sectionForm.controls['moduleId'].value.name==ObjectNames.purchaseOrderConstants.purchaseFieldName){
      this.sectionService.getConfigurationsByModuleName('Purchase').subscribe(configs => {
        const typeConfig = configs.filter(s => s.name == ObjectNames.purchaseOrderConstants.Purchase_Submodule_Object && s.typeId == typeId)[0];
        this.allTemplates = JSON.parse(typeConfig.configurationDetails[0].configJSONValue);
        this.sectionForm.controls['typeId'].setValue(this.allTemplates[0]);

        this.sectionConfig = configs.filter(s => s.name == ObjectNames.customConstants.Purchase_Section_Object && s.typeId == sectionId)[0];
        this.allSections = JSON.parse(this.sectionConfig.configurationDetails[0].configJSONValue);
      });
    }else{
      this.sectionService.getConfigurationsByModuleName('product').subscribe(configs => {
        const typeConfig = configs.filter(s => s.name == ObjectNames.productConstants.Inventory_Types_Object && s.typeId == typeId)[0];
        this.allTemplates = JSON.parse(typeConfig.configurationDetails[0].configJSONValue);
        this.sectionForm.controls['typeId'].setValue(this.allTemplates[0]);

        this.sectionConfig = configs.filter(s => s.name == ObjectNames.customConstants.Inventory_Section_Object && s.typeId == sectionId)[0];
        this.allSections = JSON.parse(this.sectionConfig.configurationDetails[0].configJSONValue);
      });
    }


  }

  getModules() {
    this.sectionService.getAllModules().subscribe(modules => {
      this.allModuleNames = modules.filter(obj => (obj.name == ObjectNames.productConstants.productFieldName) || ( obj.name == ObjectNames.purchaseOrderConstants.purchaseFieldName)
      || (obj.name == ObjectNames.OrdersConstants.orderFieldName));
      this.inventoryObjId = this.allModuleNames[0].id;
      this.selectedModule=this.allModuleNames[0];
      this.sectionForm.controls['moduleId'].setValue( this.allModuleNames[0]);
      this.getConfigurationTypes();
    });
  }

  changeModule(){
    this.inventoryObjId=this.selectedModule.id;
    this.sectionForm.controls['moduleId'].setValue(this.selectedModule);
    this.getConfigurationTypes();
  }

  showAddCustomSection() {
    this.addEditSectionHeader = ObjectNames.customConstants.AddSectionTitle;
    this.displaySectionAddEdit = true;
    this.statusDisabled = false;
    this.isAddSection = true;
    this.sectionForm = this.fb.group({
      id: [0],
      createdBy: [this.app.userId],
      createdDate: [new Date().toISOString()],
      createdSource: [this.app.userIP],
      createdUser: [''],
      isActive: [true],
      isAvailable: [true],
      isDefault: [false],
      name: ['', [Validators.required, Validators.pattern(/^(?!\s*$).+/)]],
      systemGenerated: [false],
      module: [''],
      moduleId: [this.allModuleNames[0], Validators.required],
      typeId: [this.allTemplates[0], Validators.required],
      type: [''],
      updateSource: [this.app.userIP],
      updatedBy: [this.app.userId],
      updatedDate: [new Date().toISOString()]
    });
  }

  showEditSection(section) {
    this.checkSection(section,'edit');
    this.isAddSection = false;
    this.sectionForm.patchValue(section);
    const filteredType = this.allTemplates.filter(type => type.id == section.typeId)[0];
    this.sectionForm.controls['typeId'].setValue(filteredType);
    const filteredModule = this.allModuleNames.filter(module => module.id == section.moduleId)[0];
    this.sectionForm.controls['moduleId'].setValue(filteredModule);
    this.displaySectionAddEdit = true;
  }

  checkSection(section,action) {
    this.sectionService.checkAssociateSection(this.inventoryObjId,section.id).subscribe(check => {
      if(action=='delete'){
        if (check) {
          this.displaySectionAvailability = true;
        } else {
          this.deleteSection(section);
        }
      }else{
        if (check) {
          this.statusDisabled = true;
        } else {
          this.statusDisabled = false;
        }
      }

    })
  }

  deleteSection(section) {
    this.confirmationService.confirm({
      message: 'Do you want to delete this Section?',
      header: 'Delete Confirmation',
      icon: 'pi pi-info-circle',
      accept: () => {
        this.allSections.forEach(element => {
          if (section.id == element.id) {
            const index = this.allSections.indexOf(element);
            this.allSections.splice(index, 1);
          }
        });
        this.sectionConfig.configJSONValue = JSON.stringify(this.allSections);
        this.sectionService.updateConfiguration(this.sectionConfig).then(() => {
          this.sectionService.setSection('');
          this.messageService.add({ severity: Severity.Success, summary: this.titlecasePipe.transform(Severity.Success), detail: 'Section deleted successfully...' });
          this.getConfigurationTypes();
        }).catch(() => {
          this.messageService.add({ severity: Severity.Error, summary: this.titlecasePipe.transform(Severity.Error), detail: 'Error occurred while deleting data...' });
        });
      },
      reject: () => {
      }
    });
  }

  saveSection(value) {
    const module = value?.moduleId;
    const type = value?.typeId;
    value.typeId = type?.id;
    value.type = type?.name;
    value.moduleId = module?.id;
    value.module = module?.name;
    ////console.log(value)

    if (this.isAddSection) {
      this.addSection(value);
    } else {
      this.updateSection(value);
    }
  }

  addSection(value) {
    value.id = this.allSections.length + 1;
    this.allSections.push(value);
    this.sectionConfig.configJSONValue = JSON.stringify(this.allSections);

    this.sectionService.updateConfiguration(this.sectionConfig).then(() => {
      this.sectionService.setSection('');
      this.messageService.add({ severity: Severity.Success, summary: this.titlecasePipe.transform(Severity.Success), detail: 'Type added successfully...' });
      this.getConfigurationTypes();
      this.displaySectionAddEdit = false;
    }).catch(() => {
      this.messageService.add({ severity: Severity.Error, summary: this.titlecasePipe.transform(Severity.Error), detail: 'Error occurred while saving data...' });
    });

  }

  updateSection(value) {
    // console.log(value)
    this.allSections.forEach(element => {
      if (value.id == element.id) {
        element.name = value.name;
        element.isActive = value.isActive,
        element.isAvailable = value.isAvailable,
        element.typeId = value.typeId,
        element.type = value.type,
        element.updatedBy = this.app.userId;
        element.updatedSource = this.app.userIP;
        element.updatedDate = new Date().toISOString();
      }
    });

    this.sectionConfig.configJSONValue = JSON.stringify(this.allSections);
    this.sectionService.updateConfiguration(this.sectionConfig).then(() => {
      this.sectionService.setSection('');
      this.messageService.add({ severity: Severity.Success, summary: this.titlecasePipe.transform(Severity.Success), detail: 'Type updated successfully...' });
      this.getConfigurationTypes();
      this.displaySectionAddEdit = false;
    }).catch(() => {
      this.messageService.add({ severity: Severity.Error, summary: this.titlecasePipe.transform(Severity.Error), detail: 'Error occurred while saving data...' });
    });

  }

}
